/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Lede2Inputs */

const en_guides_lede2 = /** @type {(inputs: Guides_Lede2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are meant to be read in order if JSON is new to you, or dipped into when you hit a specific problem.
Each one ends with the tools that apply to it.`)
};

const ko_guides_lede2 = /** @type {(inputs: Guides_Lede2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 처음이라면 순서대로 읽고, 특정 문제에 부딪혔다면 필요한 편만 골라 보면 됩니다.
각 편 끝에는 그 주제에 해당하는 도구를 함께 두었습니다.`)
};

const ja_guides_lede2 = /** @type {(inputs: Guides_Lede2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONが初めてなら順番に、特定の問題に直面しているなら必要な編だけ読めばよい構成です。
各編の末尾には、その主題に対応するツールを置いています。`)
};

/**
* | output |
* | --- |
* | "They are meant to be read in order if JSON is new to you, or dipped into when you hit a specific problem. Each one ends with the tools that apply to it." |
*
* @param {Guides_Lede2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_lede2 = /** @type {((inputs?: Guides_Lede2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Lede2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_lede2(inputs)
	if (locale === "ko") return ko_guides_lede2(inputs)
	return ja_guides_lede2(inputs)
});